import { render, staticRenderFns } from "./PurchaseConfirmation.vue?vue&type=template&id=6a3994d2&scoped=true"
import script from "./PurchaseConfirmation.vue?vue&type=script&lang=js"
export * from "./PurchaseConfirmation.vue?vue&type=script&lang=js"
import style0 from "./PurchaseConfirmation.vue?vue&type=style&index=0&id=6a3994d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3994d2",
  null
  
)

export default component.exports